import { useNavigate, useParams } from "react-router";
import { Layout } from "../../UI/Layout/Layout.tsx";
import { NavBar } from "../../UI/Layout/NavBar.tsx";
import { Footer } from "../../UI/Layout/Footer.tsx";
import { FullPageLoading } from "../../UI/FullPageLoading.tsx";
import { useGetStripeOrder } from "./useGetStripeOrder.ts";
import { OrderDetailsModal } from "./StripeOrderDetailsModal.tsx";
import { useEffect } from "react";
import { AdminStripeAllOrdersScreenPath } from "./AdminStripeAllOrdersScreen.tsx";
import { STRIPE_ORDER_DETAILS_PATH } from "./stripeOrderDetailsPath.ts";

export const StripeOrderDetailsScreenPath = STRIPE_ORDER_DETAILS_PATH;

export function StripeOrderDetailsScreen() {
  const { orderId } = useParams<{ orderId: string }>();
  const navigate = useNavigate();
  const { order, isLoading, error, mutate } = useGetStripeOrder(orderId);

  useEffect(() => {
    if (error) {
      console.error("Errore nel caricamento dell'ordine:", error);
    }
  }, [error]);

  if (isLoading) {
    return <FullPageLoading />;
  }

  if (!order || error) {
    return (
      <Layout>
        <NavBar />
        <div className="flex-1 flex items-center justify-center p-4">
          <div className="text-center">
            <h2 className="text-2xl font-bold text-gray-900 mb-2">
              Ordine non trovato
            </h2>
            <p className="text-gray-600 mb-4">
              L'ordine con ID "{orderId}" non è stato trovato.
            </p>
            <button
              onClick={() => navigate(AdminStripeAllOrdersScreenPath)}
              className="text-blue-600 hover:text-blue-800 underline"
            >
              Torna agli ordini
            </button>
          </div>
        </div>
        <Footer />
      </Layout>
    );
  }

  return (
    <Layout>
      <NavBar />
      <OrderDetailsModal
        order={order}
        onClose={() => {
          if (window.history.length > 1) {
            navigate(-1);
          } else {
            navigate(AdminStripeAllOrdersScreenPath);
          }
        }}
        onOrderUpdated={() => {
          mutate();
        }}
      />
      <Footer />
    </Layout>
  );
}
